import {ListAdminNews} from './list-admin-news';

export default ListAdminNews;